import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import Button, { ButtonColor, ButtonSize, ButtonWidth } from '../../ui/Button';
import Popover from '../../ui/Popover/Popover';
import Input, { InputSize, InputType } from '../../ui/Input/Input';
import InputOption from '../../ui/Input/InputOption';
import Menu from '../../ui/Menu/Menu';
import MenuOption from '../../ui/Menu/MenuOption';
import Slider, { SliderOrientation, SliderSize } from '../../ui/Slider';
import Toggle, { ToggleSize } from '../../ui/Toggle';
import Checkbox from '../../ui/Checkbox';
import Separator, { SeparatorColor, SeparatorOrientation } from '../../ui/Separator';
import Loading from '../../ui/Loading/Loading';
import ProgressWave from '../../ui/Progress/ProgressLiquid';
import ProgressDot from '../../ui/Progress/ProgressDot';
import LoadingPulse from '../../ui/Loading/LoadingPulse';
import ProgressBar from '../../ui/Progress/ProgressBar';
import { ProgressShape } from '../../ui/Progress/Progress';
import { openNotification } from '../../services/notification';

interface Props {

}

export default function Settings({ }: Props) {
    const [a, setA] = useState(true);
    const [b, setB] = useState(0);

    const [progress, setProgress] = useState(70);

    const moreButtonRef = useRef<HTMLElement>(null);
    const dropperRef: any = useRef();

    // useEffect(() => {
    //     console.log('hui')
    //     const interval = setInterval(() => {
    //         setProgress((progress + 10) % 110);
    //         console.log('hui')
    //     }, 1000);
    //     return () => clearInterval(interval);
    // }, [progress]);

    return (
        <Wrapper>
            <div>Settings</div>

            <Input type={InputType.INPUT} size={InputSize.LARGE} name='Username'></Input>
            <Input type={InputType.DATE} size={InputSize.LARGE} name='Date of birth'></Input>
            <Input type={InputType.SELECT} size={InputSize.LARGE} name='Time Zone'>
                <InputOption value='UTC'>UTC - Coordinated Universal Time</InputOption>
                <InputOption value='AST'>AST - Atlantic Standard Time</InputOption>
                <InputOption value='EST'>EST - Eastern Standard Time</InputOption>
                <InputOption value='CST'>CST - Central Standard Time</InputOption>
                <InputOption value='MST'>MST - Mountain Standard Time</InputOption>
                <InputOption value='PST'>PST - Pacific Standard Time</InputOption>
                <InputOption value='AKST'>AKST - Alaskan Standard Time</InputOption>
                <InputOption value='GMT'>GMT+0 - Greenwich Mean Time</InputOption>
            </Input>

            <div className='save flex center padding-10'>
                <Button onClick={() => console.log('settings click button')} size={ButtonSize.LARGE} color={ButtonColor.PRIMARY}>Done</Button>
            </div> {/* shouldnt be in taskEdit */}
            <Separator></Separator>
            <Toggle value={a} setValue={() => { }}></Toggle>
            <Toggle value={a} setValue={() => { }} size={ToggleSize.SMALL}></Toggle>

            <Button ref={moreButtonRef} width={ButtonWidth.CONTENT} onClick={() => dropperRef.current.open()} size={ButtonSize.LARGE}>Big Button & Dropper</Button>
            <Popover ref={dropperRef} targetRef={moreButtonRef}>suck my cock</Popover>
            <Button onClick={() => console.log('bum')} size={ButtonSize.MEDIUM}>Medium Button</Button>
            <Button onClick={() => console.log('bum')} size={ButtonSize.SMALL}>Small Button</Button>
            <Checkbox onChange={() => { }}></Checkbox>
            <Slider size={SliderSize.SMALL} onChange={() => { }} value={44} marks={[{ value: 0, label: '0' }, { value: 70, label: '70' }, { value: 100, label: '100' }]}></Slider>
            <Slider isRange onChange={() => { }} value={[30, 80]}></Slider>
            <Slider orientation={SliderOrientation.VERTICAL} size={SliderSize.SMALL} onChange={() => { }} value={44} marks={[{ value: 0, label: '0°C' }, { value: 70, label: '70°C' }, { value: 100, label: '100°C' }]} customLabel={(value) => `Temp: ${value}°C`}></Slider>
            <Slider size={SliderSize.LARGE} min={0} max={150} value={40} onChange={() => { }} marks={[{ value: 0, label: '0' }, { value: 70, label: '70' }, { value: 100, label: '100' }, { value: 150, label: '150', color: '#b81e44' }]} step='marks' customLabel={(value) => `Volume: ${value}%`}></Slider>

            <Menu value={10} onChange={() => 10}>
                <MenuOption value={1}>Option1</MenuOption>
                <MenuOption value={2}>Option2</MenuOption>
                <MenuOption value={3}>Option3</MenuOption>
                <MenuOption value={4}>Option4</MenuOption>
            </Menu>

            <Separator orientation={SeparatorOrientation.HORIZONTAL} color={SeparatorColor.SHADE}></Separator>
            <Loading></Loading>
            <ProgressDot value={progress}></ProgressDot>
            <ProgressWave value={progress} height={120} width={100} />

            <LoadingPulse></LoadingPulse>
            <ProgressBar value={progress} size={3}></ProgressBar>

            <Loading shape={ProgressShape.BAR}></Loading>
            <div style={{ minHeight: 100 }}><ProgressBar orientation='vertical' value={progress}></ProgressBar></div>
            <Button color={ButtonColor.PRIMARY} size={ButtonSize.SMALL} onClick={() => openNotification({ title: 'test notification' })}>Show Notification</Button>
            <Button color={ButtonColor.PRIMARY} size={ButtonSize.SMALL}>Show Toast</Button>
        </Wrapper>
    )
}

const Wrapper = styled.div`
    display: grid;
    grid-template-columns: 3fr 3fr 3fr 3fr;
    grid-template-rows: auto;
    gap: 10px;
`